import React,{Component} from 'react';
import { Link } from 'react-router-dom';
import Profile from '../SideBar/Profile';
import SideMenu from '../SideBar/SideMenu';
//import '../../css/custom.css';
class SideNav extends Component {

    render(){
        return(
            <div className="col-md-3 left_col">
            <div className="left_col scroll-view">
              <div className="navbar nav_title" style={{border: 0}}>
                <div className="site_title" >
                  <span>
                    <img src={process.env.PUBLIC_URL+"assets/images/white-logo.png"} alt='logo' /></span>
                </div>
              </div>
              <div className="clearfix"></div>
              <Profile />
              <SideMenu />
            </div>
          </div>
        ) 
            
    }
}

export default SideNav;


// WEBPACK FOOTER //
// ./src/components/SideBar/SideNav.js